import { useEffect } from "react";

export default function useSystemInside() {
  useEffect(() => {
    window.Notification.requestPermission().then((result) =>
      console.log(result)
    );
  }, []);
}
